import React from 'react';
import OnboardingLayoutFlowHeader from './FlowHeader';
import OnboardingLayoutPageContainer from './PageContainer';
import { StyledLayout } from './styles';

interface OnboardingLayoutProps {
  handleFormChange: () => void;
}

/**
 * Main layout component for the onboarding flow
 */
const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  handleFormChange,
}) => {
  return (
    <StyledLayout>
      <OnboardingLayoutFlowHeader />
      <OnboardingLayoutPageContainer handleFormChange={handleFormChange} />
    </StyledLayout>
  );
};

export default OnboardingLayout;
